import { useCallback, useEffect, useState } from "react";
import { createUserRequest } from "../network";

type TParams = {
  phone: string;
};

export const useUserCreate = () => {
  const [userCreated, setUserCreated] = useState(null);
  const [userCreateLoading, setUserCreateLoading] = useState(false);

  const createUserReq = useCallback(async (params: TParams) => {
    try {
      setUserCreateLoading(true);
      const res = await createUserRequest(params);
      setUserCreated(res.data);
      setUserCreateLoading(false);
      return res;
    } catch (e) {
      alert(e);
      setUserCreated([]);
      setUserCreateLoading(false);
    }
  }, []);

  return { userCreated, userCreateLoading, createUserReq };
};
